export default __webpack_public_path__ + "static/media/bs.3d9b9dc7.svg";